
import React, { Component}  from 'react';

import Layout  from 'components/Dashboard/Layout';

import {ListContext} from 'core/ListProvider';
import { Paper, TableContainer } from '@material-ui/core';
import { OrderFullTable } from './FullTable';
import TableListFooter from 'core/TableListFooter';
import OrderDetail from './Detail';
import { Drawer } from 'ui/Drawer';
import { ResponsiveTable } from 'ui/Table';
import OrderListTableFilter from './ListTableFilter';
import FollowSize from "../../core/FollowSize";


const MOBILE_MAX_WIDTH = 767;


export default class OrderListTable extends Component {

  static defaultProps = {
    apiUrl: 'order',
    basePath: '/order',
  };

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      detailId: null,
      isMobile: window.innerWidth <= MOBILE_MAX_WIDTH,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  getPreviewId = () => {
    if (this.props.previewId !== undefined) {
      return this.props.previewId;
    }
    return this.state.detailId;
  };

  isPreviewOpen = () => {
    return this.getPreviewId() !== undefined && this.getPreviewId() !== null;
  };

  openPreview = (item) => {
    if (this.props.onPreview) {
      this.props.onPreview(item);
      return;
    }
    this.setState({
      detailId: item ? item.id : undefined,
      isDrawerOpen: true,
    });
  };

  closePreview = () => {
    if (this.props.onClosePreview) {
      this.props.onClosePreview();
      return;
    }
    this.setState({
      detailId: undefined,
      isDrawerOpen: false,
    });
  };

  render() {
    const { isFilterDrawerOpen, onCloseFilters } = this.props;
    const { isMobile } = this.state;

    return (
      <ListContext.Consumer>
        {context => {
          const {items} = context;

          const table = (
            <ResponsiveTable stickyHeader={!isMobile}>
              <OrderFullTable
                items={items}
                onDetail={(item) => this.openPreview(item)}
                context={context}
              />
              <TableListFooter showPerPageSelector={true} colspan={9}/>
            </ResponsiveTable>
          );

          return (
            <Layout.ContentSimple>
              <Drawer
                open={isFilterDrawerOpen}
                onClose={onCloseFilters}
                width={'400px'}
              >
                <OrderListTableFilter />
              </Drawer>

              <Paper>
                {isMobile ? (
                  <TableContainer>
                    {table}
                  </TableContainer>
                ) : (
                  <FollowSize setWidth={false} subtractHeight={130} Component={TableContainer}>
                    {table}
                  </FollowSize>
                )}
              </Paper>

              {!this.props.onPreview && (
                <Drawer
                  open={this.isPreviewOpen()}
                  onClose={() => this.closePreview()}
                  width={'450px'}
                  disableEscapeKeyDown={true}
                >
                  <OrderDetail
                    id={this.getPreviewId()}
                    onClose={this.closePreview}
                    apiUrl={this.props.apiUrl}
                    basePath={this.props.basePath}
                    fromPath={this.props.listPath ? `${this.props.listPath}/preview/${this.getPreviewId()}` : undefined}
                  />
                </Drawer>
              )}
            </Layout.ContentSimple>
          )
        }}
      </ListContext.Consumer>
    )
  }
}
